import { parsePhoneNumberFromString } from "libphonenumber-js/max";

export const PHONE_EXACTLY_TEN_MSG = "Phone number must be exactly 10 digits.";

/** Strip non-digits and cap length (default 10). */
export function digitsOnlyPhone(value, maxLen = 10) {
  return String(value ?? "").replace(/\D/g, "").slice(0, maxLen);
}

/** National 10-digit storage only — strips +1 / +91 prefixes, never stores country codes. */
export function nationalPhoneForStorage(phone) {
  const d = String(phone ?? "").replace(/\D/g, "");
  if (!d) return "";
  if (d.length === 11 && d[0] === "1") return d.slice(1);
  if (d.length === 12 && d.startsWith("91")) return d.slice(2);
  if (d.length > 10) return d.slice(-10);
  return d;
}

/**
 * National 10-digit phone validation.
 * @param {string} number
 * @param {{ allowEmpty?: boolean }} opts
 */
export function validateTenDigitMobile(number, { allowEmpty = true } = {}) {
  const digits = digitsOnlyPhone(number, 10);
  if (!digits) {
    return allowEmpty ? "" : "Mobile is Required";
  }
  if (!/^\d{10}$/.test(digits)) {
    return PHONE_EXACTLY_TEN_MSG;
  }
  return "";
}

export const INVALID_NANP_MOBILE_MSG =
  "Enter a valid US, Canada, or other +1 area mobile number.";

export const INVALID_STORED_SMS_MOBILE_MSG =
  "Enter a valid US/Canada/+1 or India mobile number.";

/**
 * Valid +1 NANP mobile (US, Canada, Puerto Rico, USVI, etc.).
 * Twilio SMS uses +1; do not force country=US or Canada numbers fail.
 */
export function isValidNanpSmsNationalMobile(phone) {
  const ten = nationalPhoneForStorage(phone);
  if (!/^\d{10}$/.test(ten)) return false;
  const parsed = parsePhoneNumberFromString(`+1${ten}`);
  return Boolean(parsed?.isValid() && parsed.countryCallingCode === "1");
}

/** India mobiles stored as national 10 digits (Firebase Auth may use +91). */
export function isValidIndiaSmsNationalMobile(phone) {
  const ten = nationalPhoneForStorage(phone);
  if (!/^\d{10}$/.test(ten)) return false;
  const parsed = parsePhoneNumberFromString(`+91${ten}`, "IN");
  return Boolean(parsed?.isValid());
}

/** Employee/user storage: NANP (+1) or India. */
export function isValidStoredSmsNationalMobile(phone) {
  return (
    isValidNanpSmsNationalMobile(phone) || isValidIndiaSmsNationalMobile(phone)
  );
}

/** Alias kept for SMS callers — means NANP (+1), not US-only. */
export function isValidUsSmsNationalMobile(phone) {
  return isValidNanpSmsNationalMobile(phone);
}

export function validateNanpSmsMobile(number, { allowEmpty = true } = {}) {
  const tenDigit = validateTenDigitMobile(number, { allowEmpty });
  if (tenDigit) return tenDigit;
  if (!String(number ?? "").trim()) return "";
  return isValidNanpSmsNationalMobile(number) ? "" : INVALID_NANP_MOBILE_MSG;
}

export function validateStoredSmsMobile(number, { allowEmpty = true } = {}) {
  const tenDigit = validateTenDigitMobile(number, { allowEmpty });
  if (tenDigit) return tenDigit;
  if (!String(number ?? "").trim()) return "";
  return isValidStoredSmsNationalMobile(number) ? "" : INVALID_STORED_SMS_MOBILE_MSG;
}
